module.exports = __webpack_public_path__ + "e7f9e614f5ba906b279f8bb8ca3e32fd.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/ic-set-menu.png
// module id = 3155
// module chunks = 0